module.exports = __webpack_public_path__ + "static/media/HuguesDeBuyer.3f399895.jpg";